import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import LegalPageLayout from "./LegalPageLayout";

const content = {
  fr: {
    title: "Conditions Générales de Vente",
    sections: [
      {
        title: "Objet",
        text: "Les présentes CGV régissent les transactions entre vendeurs et acheteurs sur la plateforme LëtzServices. LëtzServices agit uniquement comme intermédiaire de mise en relation.",
      },
      {
        title: "Prix et paiement",
        items: [
          "Les prix sont fixés librement par les vendeurs",
          "Les prix affichés sont en euros (€)",
          "Le paiement s'effectue directement entre l'acheteur et le vendeur",
          "LëtzServices ne prélève aucune commission sur les ventes",
        ],
      },
      {
        title: "Livraison et remise",
        text: "Les modalités de remise du bien (en main propre, envoi postal) sont convenues directement entre l'acheteur et le vendeur. Nous recommandons les échanges en personne dans un lieu public.",
      },
      {
        title: "Garanties",
        text: "Les produits vendus entre particuliers ne bénéficient pas de la garantie légale de conformité. Le vendeur reste responsable des vices cachés conformément au Code civil luxembourgeois.",
      },
      {
        title: "Droit de rétractation",
        text: "Les ventes entre particuliers ne sont pas soumises au droit de rétractation de 14 jours prévu pour les ventes à distance professionnelles.",
      },
      {
        title: "Litiges",
        text: "En cas de litige, nous encourageons les parties à trouver un accord amiable. LëtzServices ne peut être tenu responsable des transactions effectuées entre utilisateurs.",
      },
    ],
  },
  en: {
    title: "Terms of Sale",
    sections: [
      {
        title: "Purpose",
        text: "These Terms of Sale govern transactions between sellers and buyers on the LëtzServices platform. LëtzServices acts solely as a connection intermediary.",
      },
      {
        title: "Price and Payment",
        items: [
          "Prices are freely set by sellers",
          "Displayed prices are in euros (€)",
          "Payment is made directly between buyer and seller",
          "LëtzServices does not charge any commission on sales",
        ],
      },
      {
        title: "Delivery and Handover",
        text: "The handover method (in person, postal delivery) is agreed directly between buyer and seller. We recommend in-person exchanges in public places.",
      },
      {
        title: "Warranties",
        text: "Products sold between individuals do not benefit from the legal guarantee of conformity. The seller remains responsible for hidden defects in accordance with Luxembourg Civil Code.",
      },
      {
        title: "Right of Withdrawal",
        text: "Sales between individuals are not subject to the 14-day withdrawal right provided for professional distance sales.",
      },
      {
        title: "Disputes",
        text: "In case of dispute, we encourage parties to find an amicable agreement. LëtzServices cannot be held responsible for transactions between users.",
      },
    ],
  },
};

const TermsOfSalePage = () => {
  const { lang } = useLanguage();
  return <LegalPageLayout content={content[lang] || content.fr} />;
};

export default TermsOfSalePage;
